/**
 * JUST MATS — Custom Global JS
 * ─────────────────────────────────────────────────────────────────
 * Ausgelagerte Datei damit theme.liquid sauber bleibt und Updates
 * nicht die gesamte Logik überschreiben.
 *
 * Referenziert in theme.liquid via:
 *   <script src="{{ 'just-mats-custom.js' | asset_url }}" defer></script>
 *
 * Settings werden aus window.JustMatsConfig gelesen — dieses Objekt
 * wird in theme.liquid per Liquid-Inline-Script befüllt:
 *   window.JustMatsConfig = { aosEnable: true, aosType: "fade-up" }
 *
 * Anpassungen hier vornehmen — NICHT in theme.liquid!
 * ─────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  var config = window.JustMatsConfig || {};

  document.addEventListener('DOMContentLoaded', function () {

    // ── AOS initialisieren ───────────────────────────────────────
    if (typeof AOS !== 'undefined') {
      AOS.init({
        once: true,
        duration: 600,
        offset: 60
      });
    }

    // ── Gleicher Color Scheme: Margin zwischen Sections entfernen ─
    // Zwei aufeinanderfolgende Sections mit identischem color-scheme-X
    // erhalten die Klasse .jm-same-scheme-as-prev → margin-top: 0
    (function () {
      var sections = Array.from(document.querySelectorAll('.shopify-section'));
      sections.forEach(function (section, index) {
        if (index === 0) return;
        var prev = sections[index - 1];
        var prevInner = prev.firstElementChild;
        var currInner = section.firstElementChild;
        if (!prevInner || !currInner) return;

        var prevScheme = Array.from(prevInner.classList).find(function (c) {
          return c.startsWith('color-scheme-');
        });
        var currScheme = Array.from(currInner.classList).find(function (c) {
          return c.startsWith('color-scheme-');
        });

        if (prevScheme && currScheme && prevScheme === currScheme) {
          section.classList.add('jm-same-scheme-as-prev');
        }
      });
    })();

    // ── Transparenter Header auf Startseite ──────────────────────
    // CSS-First: header.liquid gibt per {%- style -%} sofort beim Render alle
    // Transparent-Styles aus → kein FOUC mehr, kein Warten auf DOMContentLoaded.
    // JS verwaltet nur noch den Scroll-State:
    //  • Scroll > 5px  → .jm-scrolled auf .section-header → CSS: position:sticky
    //  • Scroll ≤ 5px  → .jm-scrolled entfernen + Preheader-Offset setzen
    (function () {
      var headerEl = document.querySelector('[data-jm-transparent]');
      if (!headerEl) return;

      var sectionHeader = headerEl.closest('.section-header');
      if (!sectionHeader) return;

      function getPreheaderHeight() {
        var prev = sectionHeader.previousElementSibling;
        return (prev && prev.offsetHeight) ? prev.offsetHeight : 0;
      }

      function setPreheaderVar() {
        var preH = getPreheaderHeight();
        // CSS-Variable für Sections die 100vh minus Preheader brauchen (z.B. Panels)
        document.documentElement.style.setProperty('--jm-preheader-height', preH + 'px');
      }

      function updateState() {
        if (window.scrollY > 5) {
          sectionHeader.classList.add('jm-scrolled');
          sectionHeader.style.top = '';
        } else {
          sectionHeader.classList.remove('jm-scrolled');
          var preH = getPreheaderHeight();
          sectionHeader.style.top = preH > 0 ? preH + 'px' : '';
        }
      }

      window.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', setPreheaderVar, { passive: true });
      setPreheaderVar();
      updateState();
    })();

    // Fallback: Preheader-Höhe auch ohne transparenten Header setzen
    // (z.B. wenn kein transparenter Header aktiv, Panels aber trotzdem 100vh nutzen)
    (function () {
      if (document.querySelector('[data-jm-transparent]')) return; // bereits oben gesetzt
      var preheader = document.querySelector('.shopify-section:first-child .announcement-bar, .announcement-bar-section');
      var preH = preheader ? preheader.offsetHeight : 0;
      document.documentElement.style.setProperty('--jm-preheader-height', preH + 'px');
    })();

    // ── Variant-Bilder vorladen (Hover + TouchStart + Idle) ─────────
    // Problem: versteckte Variant-Bilder und Thumbnails werden nie
    // lazy-geladen → beim Variantenwechsel lädt der Browser von Null.
    //
    // Strategie A — Hover (Desktop): Maus über Varianten-Optionen
    // Strategie B — TouchStart (Mobile): Finger tippt Swatch an.
    //   touchstart feuert ~150-200ms VOR click → Bilder starten laden
    //   bevor der Tap-Effekt überhaupt sichtbar wird.
    // Strategie C — Idle-Fallback: requestIdleCallback nach 800ms
    //   (deckt Tastatur-Navigation + verzögertes Scrollen ab)
    //
    // Bilder per new Image() + decode() vorgeladen → Cache befüllt,
    // GPU-Decode im Hintergrund. Bei saveData / 2G: C übersprungen.
    (function () {
      var gallery = document.querySelector('media-gallery');
      if (!gallery) return;

      var done = false;

      function preloadImg(img) {
        if (!img || (img.complete && img.naturalWidth > 0)) return;
        if (!img.src && !img.dataset.src) return;
        var p = new Image();
        p.decoding = 'async';
        p.src = img.src || img.dataset.src;
        if (img.srcset) { p.srcset = img.srcset; p.sizes = img.sizes; }
        // decode() startet GPU-Decode im Worker-Thread → sofort renderfähig
        if (typeof p.decode === 'function') p.decode().catch(function () {});
      }

      function preloadAll() {
        if (done) return;
        done = true;
        // 1) Alle nicht-aktiven Galerie-Slides (große Bilder)
        gallery.querySelectorAll('.product__media-item:not(.is-active) img').forEach(preloadImg);
        // 2) ALLE Thumbnails — inkl. versteckte Variant-Thumbnails
        document.querySelectorAll('.thumbnail-list img, .thumbnail-slider img').forEach(preloadImg);
      }

      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var slow = conn && (conn.saveData || /^(2g|slow-2g)$/.test(conn.effectiveType || ''));

      // Strategie A: Hover (Desktop)
      var productForm = document.querySelector('.product-form__input, .variant-input-wrapper');
      if (productForm) {
        (productForm.closest('form') || document).addEventListener(
          'mouseenter', preloadAll, { once: true, capture: true }
        );
      }

      // Strategie B: TouchStart auf Swatch-Labels — 150-200ms vor click
      // Sobald Finger Variante berührt, startet Preload sofort
      var swatchArea = document.querySelector('.product__info-wrapper, .product-form, .variant-input-wrapper');
      if (swatchArea) {
        swatchArea.addEventListener('touchstart', preloadAll, { once: true, passive: true });
      }

      // Strategie C: Idle-Fallback (langsame Verbindungen überspringen)
      if (!slow) {
        if (window.requestIdleCallback) {
          requestIdleCallback(preloadAll, { timeout: 800 });
        } else {
          setTimeout(preloadAll, 800);
        }
      }
    })();

    // ── Globale Sektions-Animationen ─────────────────────────────
    // Wenn im Customizer aktiviert: alle .shopify-section Elemente
    // erhalten automatisch data-aos mit dem gewählten Animationstyp.
    // Sektionen mit bereits vorhandenem data-aos werden übersprungen.
    if (config.aosEnable && typeof AOS !== 'undefined') {
      var aosType = config.aosType || 'fade-up';

      document.querySelectorAll('.shopify-section').forEach(function (section) {
        // Header und Footer überspringen
        if (section.closest('header') || section.closest('footer')) return;

        var inner = section.firstElementChild;
        if (inner && !inner.hasAttribute('data-aos')) {
          inner.setAttribute('data-aos', aosType);
          // AOS nachträglich auf das neue Element anwenden
          AOS.refreshHard();
        }
      });
    }

  });

})();
